module.exports = __webpack_public_path__ + "assets/e40f1d8b632f56547934c9603821a30a.png";